import { intersection } from 'lodash'
import routeParams from 'helpers/routeParams'
import { sameIdsIn } from 'utils/array'
import { PARTICIPANTS_BULK } from 'constants/enums'
import { mapForBulk } from 'redux/selectors/participants/mapParticipantsForBulk'
import { get } from 'lodash'
import {
  getApiPaging,
  getApiSort,
  getApiFilterBuilder
} from '../../../utils/apig02/apig02'

const GET_PARTICIPANTS_LIST = 'dofe-bo/participant/GET_PARTICIPANTS_LIST'
const GET_PARTICIPANTS_LIST_SUCCESS ='dofe-bo/participant/GET_PARTICIPANTS_LIST_SUCCESS'
const GET_PARTICIPANTS_LIST_FAIL = 'dofe-bo/participant/GET_PARTICIPANTS_LIST_FAIL'

const GET_PARTICIPANTS_GRID_LIST = 'dofe-bo/participant/GET_PARTICIPANTS_GRID_LIST'
const GET_PARTICIPANTS_GRID_LIST_SUCCESS ='dofe-bo/participant/GET_PARTICIPANTS_GRID_LIST_SUCCESS'
const GET_PARTICIPANTS_GRID_LIST_FAIL = 'dofe-bo/participant/GET_PARTICIPANTS_GRID_LIST_FAIL'

const GET_PARTICIPANTS_GRID_COUNT = 'dofe-bo/participant/GET_PARTICIPANTS_GRID_COUNT'
const GET_PARTICIPANTS_GRID_COUNT_SUCCESS ='dofe-bo/participant/GET_PARTICIPANTS_GRID_COUNT_SUCCESS'
const GET_PARTICIPANTS_GRID_COUNT_FAIL = 'dofe-bo/participant/GET_PARTICIPANTS_GRID_COUNT_FAIL'

const SET_GRID_FILTER = 'dofe-bo/participant/SET_GRID_FILTER'
const SET_GRID_PARAMS = 'dofe-bo/participant/SET_GRID_PARAMS'

const GET_ASSESSOR_ACTIVITY_PARTICIPANTS_LIST = 'dofe-bo/participant/GET_ASSESSOR_ACTIVITY_PARTICIPANTS_LIST'
const GET_ASSESSOR_ACTIVITY_PARTICIPANTS_LIST_SUCCESS ='dofe-bo/participant/GET_ASSESSOR_ACTIVITY_PARTICIPANTS_LIST_SUCCESS'
const GET_ASSESSOR_ACTIVITY_PARTICIPANTS_LIST_FAIL = 'dofe-bo/participant/GET_ASSESSOR_ACTIVITY_PARTICIPANTS_LIST_FAIL'
const GET_ASSESSOR_AJ_PARTICIPANTS_LIST = 'dofe-bo/participant/GET_ASSESSOR_AJ_PARTICIPANTS_LIST'
const GET_ASSESSOR_AJ_PARTICIPANTS_LIST_SUCCESS ='dofe-bo/participant/GET_ASSESSOR_AJ_PARTICIPANTS_LIST_SUCCESS'
const GET_ASSESSOR_AJ_PARTICIPANTS_LIST_FAIL = 'dofe-bo/participant/GET_ASSESSOR_AJ_PARTICIPANTS_LIST_FAIL'
const GET_ASSESSOR_RP_PARTICIPANTS_LIST = 'dofe-bo/participant/GET_ASSESSOR_RP_PARTICIPANTS_LIST'
const GET_ASSESSOR_RP_PARTICIPANTS_LIST_SUCCESS ='dofe-bo/participant/GET_ASSESSOR_RP_PARTICIPANTS_LIST_SUCCESS'
const GET_ASSESSOR_RP_PARTICIPANTS_LIST_FAIL = 'dofe-bo/participant/GET_ASSESSOR_RP_PARTICIPANTS_LIST_FAIL'

const SET_PARTICIPANTS_LIST_SELECTED = 'dofe-bo/participant/SET_PARTICIPANTS_LIST_SELECTED'
const TOGGLE_PARTICIPANTS_ALL_SELECTED = 'dofe-bo/participant/TOGGLE_PARTICIPANTS_ALL_SELECTED'
const GET_PARTICIPANT = 'dofe-bo/participant/GET_PARTICIPANT'
const GET_PARTICIPANT_SUCCESS = 'dofe-bo/participant/GET_PARTICIPANT_SUCCESS'
const GET_PARTICIPANT_FAIL = 'dofe-bo/participant/GET_PARTICIPANT_FAIL'
const GET_PARTICIPANT_SUMMARY = 'dofe-bo/participant/GET_PARTICIPANT_SUMMARY'
const GET_PARTICIPANT_SUMMARY_SUCCESS = 'dofe-bo/participant/GET_PARTICIPANT_SUMMARY_SUCCESS'
const GET_PARTICIPANT_SUMMARY_FAIL = 'dofe-bo/participant/GET_PARTICIPANT_SUMMARY_FAIL'
const CREATE_PARTICIPANT = 'dofe-bo/participant/CREATE_PARTICIPANT'
const CREATE_PARTICIPANT_SUCCESS =
  'dofe-bo/participant/CREATE_PARTICIPANT_SUCCESS'
const CREATE_PARTICIPANT_FAIL = 'dofe-bo/participant/CREATE_PARTICIPANT_FAIL'
const DELETE_PARTICIPANT = 'dofe-bo/participant/DELETE_PARTICIPANT'
const DELETE_PARTICIPANT_SUCCESS =
  'dofe-bo/participant/DELETE_PARTICIPANT_SUCCESS'
const DELETE_PARTICIPANT_FAIL = 'dofe-bo/participant/DELETE_PARTICIPANT_FAIL'
const UPDATE_PARTICIPANT = 'dofe-bo/participant/UPDATE_PARTICIPANT'
const UPDATE_PARTICIPANT_SUCCESS =
  'dofe-bo/participant/UPDATE_PARTICIPANT_SUCCESS'
const UPDATE_PARTICIPANT_FAIL = 'dofe-bo/participant/UPDATE_PARTICIPANT_FAIL'
const APPROVE_PARTICIPANT = 'dofe-bo/participant/APPROVE_PARTICIPANT'
const APPROVE_PARTICIPANT_SUCCESS =
  'dofe-bo/participant/APPROVE_PARTICIPANT_SUCCESS'
const APPROVE_PARTICIPANT_FAIL = 'dofe-bo/participant/APPROVE_PARTICIPANT_FAIL'

const SEND_EMAIL_INVITE = 'dofe-bo/participant/SEND_EMAIL_INVITE'
const SEND_EMAIL_INVITE_SUCCESS =
  'dofe-bo/participant/SEND_EMAIL_INVITE_SUCCESS'
const SEND_EMAIL_INVITE_FAIL = 'dofe-bo/participant/SEND_EMAIL_INVITE_FAIL'

const SEND_CONFIRM_EMAIL = 'dofe-bo/participant/SEND_CONFIRM_EMAIL'
const SEND_CONFIRM_EMAIL_SUCCESS =
  'dofe-bo/participant/SEND_CONFIRM_EMAIL_SUCCESS'
const SEND_CONFIRM_EMAIL_FAIL = 'dofe-bo/participant/SEND_CONFIRM_EMAIL_FAIL'

const PASSWORD_REQUEST_RESET = 'dofe-bo/participant/PASSWORD_REQUEST_RESET'
const PASSWORD_REQUEST_RESET_SUCCESS =
  'dofe-bo/participant/PASSWORD_REQUEST_RESET_SUCCESS'
const PASSWORD_REQUEST_RESET_FAIL =
  'dofe-bo/participant/PASSWORD_REQUEST_RESET_FAIL'

const EXPORT_PARTICIPANTS_LIST = 'dofe-bo/participant/EXPORT_PARTICIPANTS_LIST'
const EXPORT_PARTICIPANTS_LIST_SUCCESS =
  'dofe-bo/participant/EXPORT_PARTICIPANTS_LIST_SUCCESS'
const EXPORT_PARTICIPANTS_LIST_FAIL =
  'dofe-bo/participant/EXPORT_PARTICIPANTS_LIST_FAIL'

const EXPORT_PARTICIPANTS_GRID_LIST = 'dofe-bo/participant/EXPORT_PARTICIPANTS_GRID_LIST'
const EXPORT_PARTICIPANTS_GRID_LIST_SUCCESS =
  'dofe-bo/participant/EXPORT_PARTICIPANTS_GRID_LIST_SUCCESS'
const EXPORT_PARTICIPANTS_GRID_LIST_FAIL =
  'dofe-bo/participant/EXPORT_PARTICIPANTS_GRID_LIST_FAIL'

const REMOVE_PART_REG = 'dofe-bo/participant/REMOVE_PART_REG'
const REMOVE_PART_REG_SUCCESS = 'dofe-bo/participant/REMOVE_PART_REG_SUCCESS'
const REMOVE_PART_REG_FAIL = 'dofe-bo/participant/REMOVE_PART_REG_FAIL'

const SET_FILTER = 'dofe-bo/participant/SET_FILTER'
const SET_PARAMS = 'dofe-bo/participant/SET_PARAMS'

const SET_ASS_ACT_PART_FILTER = 'dofe-bo/participant/SET_ASSESSOR_ACT_PART_FILTER'
const SET_ASS_ACT_PART_PARAMS = 'dofe-bo/participant/SET_ASS_ACT_PART_PARAMS'
const SET_ASS_AJ_PART_FILTER = 'dofe-bo/participant/SET_ASS_AJ_PART_FILTER'
const SET_ASS_AJ_PART_PARAMS = 'dofe-bo/participant/SET_ASS_AJ_PART_PARAMS'
const SET_ASS_RP_PART_FILTER = 'dofe-bo/participant/SET_ASS_RP_PART_FILTER'
const SET_ASS_RP_PART_PARAMS = 'dofe-bo/participant/SET_ASS_RP_PART_PARAMS'

const SET_DISABLED_CACHE = 'dofe-bo/participant/SET_DISABLED_CACHE'
const REMOVE_DETAIL_DATA = 'dofe-bo/participant/REMOVE_DETAIL_DATA'
const SET_INITIAL_PARAMS = 'dofe-bo/participant/SET_INITIAL_PARAMS'

const BULK_PARTICIPANTS_RESET = 'dofe-bo/participant/BULK_PARTICIPANTS_RESET'
const BULK_PARTICIPANTS = 'dofe-bo/participant/BULK_PARTICIPANTS'
const BULK_PARTICIPANTS_SUCCESS = 'dofe-bo/participant/BULK_PARTICIPANTS_SUCCESS'
const BULK_PARTICIPANTS_FAIL = 'dofe-bo/participant/BULK_PARTICIPANTS_FAIL'

const PARTICIPANTS_SERVICE_MERGE = 'dofe-bo/participant/PARTICIPANTS_SERVICE_MERGE'
const PARTICIPANTS_SERVICE_MERGE_SUCCESS = 'dofe-bo/participant/PARTICIPANTS_SERVICE_MERGE_SUCCESS'
const PARTICIPANTS_SERVICE_MERGE_FAIL = 'dofe-bo/participant/PARTICIPANTS_SERVICE_MERGE_FAIL'

const PARTICIPANTS_SERVICE_DELETE_AWARD = 'dofe-bo/participant/PARTICIPANTS_SERVICE_DELETE_AWARD'
const PARTICIPANTS_SERVICE_DELETE_AWARD_SUCCESS = 'dofe-bo/participant/PARTICIPANTS_SERVICE_DELETE_AWARD_SUCCESS'
const PARTICIPANTS_SERVICE_DELETE_AWARD_FAIL = 'dofe-bo/participant/PARTICIPANTS_SERVICE_DELETE_AWARD_FAIL'

const PARTICIPANTS_SERVICE_CHANGE_AWARD_MODE = 'dofe-bo/participant/PARTICIPANTS_SERVICE_CHANGE_AWARD_MODE'
const PARTICIPANTS_SERVICE_CHANGE_AWARD_MODE_SUCCESS = 'dofe-bo/participant/PARTICIPANTS_SERVICE_CHANGE_AWARD_MODE_SUCCESS'
const PARTICIPANTS_SERVICE_CHANGE_AWARD_MODE_FAIL = 'dofe-bo/participant/PARTICIPANTS_SERVICE_CHANGE_AWARD_MODE_FAIL'

const PARTICIPANTS_SERVICE_RECOVER = 'dofe-bo/participant/PARTICIPANTS_SERVICE_RECOVER'
const PARTICIPANTS_SERVICE_RECOVER_SUCCESS = 'dofe-bo/participant/PARTICIPANTS_SERVICE_RECOVER_SUCCESS'
const PARTICIPANTS_SERVICE_RECOVER_FAIL = 'dofe-bo/participant/PARTICIPANTS_SERVICE_RECOVER_FAIL'

const initialState = {
  list: [],
  detail: {},
  sort: '',
  offset: 0,
  limit: 20,
  pages: 4,
  count: null,
  filter: '',
  loading: false,
  loaded: false,
  selectedIds: [],
  grid: {
    list: [],
    sort: '',
    offset: 0,
    limit: 20,
    pages: 4,
    count: null,
    filter: '',
    loading: false,
    loaded: false
  },
  bulk: {
    loading: false,
    loaded: false
  },
  detailSummary: {},
  merge: {
    loading: false,
    loaded: false
  },
  recover: {
    loading: false,
    loaded: false
  },
  deleteAward: {
    loading: false,
    loaded: false
  },
  changeAwardMode: {
    loading: false,
    loaded: false
  },
  assessor: {
    activity: {
      list: [],
      sort: '',
      offset: 0,
      limit: 20,
      pages: 4,
      count: null,
      filter: '',
      loading: false,
      loaded: false,
    },
    aj: {
      list: [],
      sort: '',
      offset: 0,
      limit: 20,
      pages: 4,
      count: null,
      filter: '',
      loading: false,
      loaded: false,
    },
    rp: {
      list: [],
      sort: '',
      offset: 0,
      limit: 20,
      pages: 4,
      count: null,
      filter: '',
      loading: false,
      loaded: false,
    },
  }
}

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_PARTICIPANTS_LIST:
      return {
        ...state,
        loading: true
      }
    case GET_PARTICIPANTS_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        list: action.result,
        count: Number(action.headers['x-total-count']),
        selectedIds: [],
        pages:
          Math.ceil(Number(action.headers['x-total-count']) / state.limit) ||
          state.pages
      }
    case GET_PARTICIPANTS_LIST_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    case GET_PARTICIPANTS_GRID_LIST:
      return {
        ...state,
        grid: {
          ...state.grid,
          loading: true
        }
      }
    case GET_PARTICIPANTS_GRID_LIST_SUCCESS:
      return {
        ...state,
        grid: {
          ...state.grid,
          loading: false,
          loaded: true,
          list: action.result.list,
          selectedIds: []
        }
      }
    case GET_PARTICIPANTS_GRID_LIST_FAIL:
      return {
        ...state,
        grid: {
          ...state.grid,
          loading: false,
          loaded: false,
          error: action.error
        }
      }
    case GET_PARTICIPANTS_GRID_COUNT:
      return {
        ...state,
        grid: {
          ...state.grid,
          countLoaded: false,
          countLoading: true
        }
      }
    case GET_PARTICIPANTS_GRID_COUNT_SUCCESS:
      const totalCount = Number(get(action.result, 'totalCount') || 0)
      return {
        ...state,
        grid: {
          ...state.grid,
          countLoading: false,
          countLoaded: true,
          count: totalCount,
          pages:
            Math.ceil(totalCount / state.grid.limit) ||
            state.pages
        }
      }
    case GET_PARTICIPANTS_GRID_COUNT_FAIL:
      return {
        ...state,
        grid: {
          ...state.grid,
          countLoading: false,
          countLoaded: false,
          error: action.error
        }
      }
    case SET_GRID_FILTER:
      return {
        ...state,
        grid: {
          ...state.grid,
          filter: action.filterBy,
          offset: 0,
          invalidate: new Date().getTime()
        }
      }
    case SET_GRID_PARAMS:
      return {
        ...state,
        grid: {
          ...state.grid,
          limit:
            action.options.limit !== undefined
              ? action.options.limit
              : state.grid.limit,
          offset:
            action.options.offset !== undefined
              ? action.options.offset
              : state.grid.offset,
          filter:
            action.options.filter !== undefined
              ? action.options.filter
              : state.grid.filter,
          sort:
            action.options.sort !== undefined ? action.options.sort : state.grid.sort
        }
      }
    case GET_ASSESSOR_ACTIVITY_PARTICIPANTS_LIST:
      return {
        ...state,
        assessor: {
          ...state.assessor,
          activity: {
            ...state.assessor.activity,
            loading: true
          }
        }
      }
    case GET_ASSESSOR_ACTIVITY_PARTICIPANTS_LIST_SUCCESS:
      return {
        ...state,
        assessor: {
          ...state.assessor,
          activity: {
            ...state.assessor.activity,
            loading: false,
            loaded: true,
            list: action.result,
            count: Number(action.headers['x-total-count']),
            selectedIds: [],
            pages:
                Math.ceil(Number(action.headers['x-total-count']) /  get(state, 'assessor.activity.limit')) ||
                get(state, 'assessor.activity.pages')
          }
        }
      }
    case GET_ASSESSOR_ACTIVITY_PARTICIPANTS_LIST_FAIL:
      return {
        ...state,
        assessor: {
          ...state.assessor,
          activity: {
            ...state.assessor.activity,
            loading: false,
            loaded: false,
            error: action.error
          }
        }
      }
    case GET_ASSESSOR_AJ_PARTICIPANTS_LIST:
      return {
        ...state,
        assessor: {
          ...state.assessor,
          aj: {
            ...state.assessor.aj,
            loading: true
          }
        }
      }
    case GET_ASSESSOR_AJ_PARTICIPANTS_LIST_SUCCESS:
      return {
        ...state,
        assessor: {
          ...state.assessor,
          aj: {
            ...state.assessor.aj,
            loading: false,
            loaded: true,
            list: action.result,
            count: Number(action.headers['x-total-count']),
            selectedIds: [],
            pages:
                Math.ceil(Number(action.headers['x-total-count']) / get(state, 'assessor.aj.limit')) ||
                get(state, 'assessor.aj.pages')
          }
        }
      }
    case GET_ASSESSOR_AJ_PARTICIPANTS_LIST_FAIL:
      return {
        ...state,
        assessor: {
          ...state.assessor,
          aj: {
            ...state.assessor.aj,
            loading: false,
            loaded: false,
            error: action.error
          }
        }
      }
    case GET_ASSESSOR_RP_PARTICIPANTS_LIST:
      return {
        ...state,
        assessor: {
          ...state.assessor,
          rp: {
            ...state.assessor.rp,
            loading: true
          }
        }
      }
    case GET_ASSESSOR_RP_PARTICIPANTS_LIST_SUCCESS:
      return {
        ...state,
        assessor: {
          ...state.assessor,
          rp: {
            ...state.assessor.rp,
            loading: false,
            loaded: true,
            list: action.result,
            count: Number(action.headers['x-total-count']),
            selectedIds: [],
            pages:
                Math.ceil(Number(action.headers['x-total-count']) / get(state, 'assessor.rp.limit')) ||
                get(state, 'assessor.rp.pages')
          }
        }
      }
    case GET_ASSESSOR_RP_PARTICIPANTS_LIST_FAIL:
      return {
        ...state,
        assessor: {
          ...state.assessor,
          rp: {
            ...state.assessor.rp,
            loading: false,
            loaded: false,
            error: action.error
          }
        }
      }
    case SET_PARTICIPANTS_LIST_SELECTED:
      return {
        ...state,
        selectedIds: action.bulkType
        ? intersection(action.selectedIds,
            mapForBulk(state.list || [], action.bulkType))
        : action.selectedIds
      }
    case TOGGLE_PARTICIPANTS_ALL_SELECTED:
      if (sameIdsIn(action.selectedIds, action.selectableIds)) {
        return {
          ...state,
          selectedIds: []
        }
      }

      return {
        ...state,
        selectedIds: [...action.selectableIds]
      }
    case GET_PARTICIPANT:
      return {
        ...state,
        loading: true
      }
    case GET_PARTICIPANT_SUCCESS:
      return {
        ...state,
        loading: false,
        detail: action.result
      }
    case GET_PARTICIPANT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error
      }
    case GET_PARTICIPANT_SUMMARY:
      return {
        ...state,
        detailSummary: {
          ...state.detailSummary,
          loading: true
        }
      }
    case GET_PARTICIPANT_SUMMARY_SUCCESS:
      return {
        ...state,
        detailSummary: {
          ...state.detailSummary,
          loading: false,
          summary: action.result
        }
      }
    case GET_PARTICIPANT_SUMMARY_FAIL:
      return {
        ...state,
        detailSummary: {
          ...state.detailSummary,
          loading: false,
          error: action.error
        }
      }
      case UPDATE_PARTICIPANT:
      return {
        ...state,
        loading: true
      }
    case UPDATE_PARTICIPANT_SUCCESS:
      return {
        ...state,
        loading: false,
        detail: Object.assign({}, state.detail, action.result)
      }
    case UPDATE_PARTICIPANT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error
      }
    case SET_FILTER:
      return Object.assign({}, state, {
        filter: action.filterBy,
        offset: 0,
        invalidate: new Date().getTime()
      })
    case SET_PARAMS:
      return {
        ...state,
        limit:
          action.options.limit !== undefined
            ? action.options.limit
            : state.limit,
        offset:
          action.options.offset !== undefined
            ? action.options.offset
            : state.offset,
        filter:
          action.options.filter !== undefined
            ? action.options.filter
            : state.filter,
        sort:
          action.options.sort !== undefined ? action.options.sort : state.sort
      }
    case SET_ASS_ACT_PART_FILTER:
      return {
        ...state,
        assessor: {
          ...state.assessor,
          activity: {
            ...state.assessor.activity,
            filter: action.filterBy,
            offset: 0,
            invalidate: new Date().getTime()
          }
        }
      }
    case SET_ASS_AJ_PART_FILTER:
      return {
        ...state,
        assessor: {
          ...state.assessor,
          aj: {
            ...state.assessor.aj,
            filter: action.filterBy,
            offset: 0,
            invalidate: new Date().getTime()
          }
        }
      }
    case SET_ASS_RP_PART_FILTER:
      return {
        ...state,
        assessor: {
          ...state.assessor,
          rp: {
            ...state.assessor.rp,
            filter: action.filterBy,
            offset: 0,
            invalidate: new Date().getTime()
          }
        }
      }
    case SET_ASS_ACT_PART_PARAMS:
      return {
        ...state,
        assessor: {
          ...state.assessor,
          activity: {
            ...state.assessor.activity,
            limit:
                action.options.limit !== undefined
                    ? action.options.limit
                    : get(state, 'assessor.activity.limit'),
            offset:
                action.options.offset !== undefined
                    ? action.options.offset
                    : get(state, 'assessor.activity.offset'),
            filter:
                action.options.filter !== undefined
                    ? action.options.filter
                    : get(state, 'assessor.activity.filter'),
            sort:
                action.options.sort !== undefined ? action.options.sort : get(state, 'assessor.activity.sort')
          }
        }
      }
    case SET_ASS_AJ_PART_PARAMS:
      return {
        ...state,
        assessor: {
          ...state.assessor,
          aj: {
            ...state.assessor.aj,
            limit:
                action.options.limit !== undefined
                    ? action.options.limit
                    : get(state, 'assessor.aj.limit'),
            offset:
                action.options.offset !== undefined
                    ? action.options.offset
                    : get(state, 'assessor.aj.offset'),
            filter:
                action.options.filter !== undefined
                    ? action.options.filter
                    : get(state, 'assessor.aj.filter'),
            sort:
                action.options.sort !== undefined ? action.options.sort : get(state, 'assessor.aj.sort')
          }
        }
      }
    case SET_ASS_RP_PART_PARAMS:
      return {
        ...state,
        assessor: {
          ...state.assessor,
          rp: {
            ...state.assessor.rp,
            limit:
                action.options.limit !== undefined
                    ? action.options.limit
                    : get(state, 'assessor.rp.limit'),
            offset:
                action.options.offset !== undefined
                    ? action.options.offset
                    : get(state, 'assessor.rp.offset'),
            filter:
                action.options.filter !== undefined
                    ? action.options.filter
                    : get(state, 'assessor.rp.filter'),
            sort:
                action.options.sort !== undefined ? action.options.sort : get(state, 'assessor.rp.sort')
          }
        }
      }
    case SET_DISABLED_CACHE:
      return Object.assign({}, state, {
        loaded: false
      })
    case REMOVE_DETAIL_DATA:
      return Object.assign({}, state, {
        detail: {}
      })
    case SET_INITIAL_PARAMS:
      return Object.assign({}, state, {
        offset: 0,
        limit: 10,
        pages: 1,
        filter: '',
        loading: false,
        loaded: false
      })
    case BULK_PARTICIPANTS_RESET:
      return {
        ...state,
        bulk: {
          loading: false,
          loaded: false
        }
      }
    case BULK_PARTICIPANTS:
      return {
        ...state,
        bulk: {
          ...state.bulk,
          loading: true,
          loaded: false
        }
      }
    case BULK_PARTICIPANTS_SUCCESS:
      return {
        ...state,
        bulk: {
          ...state.bulk,
          loading: false,
          loaded: true,
          detail: action.result
        }
      }
    case BULK_PARTICIPANTS_FAIL:
      return {
        ...state,
        bulk: {
          ...state.bulk,
          loading: false,
          error: action.error
        }
      }
    case PARTICIPANTS_SERVICE_MERGE:
      return {
        ...state,
        merge: {
          ...state.merge,
          loading: true,
          loaded: false
        }
      }
    case PARTICIPANTS_SERVICE_MERGE_SUCCESS:
      return {
        ...state,
        merge: {
          ...state.merge,
          loading: false,
          loaded: true,
          detail: action.result
        }
      }
    case PARTICIPANTS_SERVICE_MERGE_FAIL:
      return {
        ...state,
        merge: {
          ...state.merge,
          loading: false,
          error: action.error
        }
      }
    case PARTICIPANTS_SERVICE_DELETE_AWARD:
      return {
        ...state,
        deleteAward: {
          ...state.deleteAward,
          loading: true,
          loaded: false
        }
      }
    case PARTICIPANTS_SERVICE_DELETE_AWARD_SUCCESS:
      return {
        ...state,
        deleteAward: {
          ...state.deleteAward,
          loading: false,
          loaded: true,
          detail: action.result
        }
      }
    case PARTICIPANTS_SERVICE_DELETE_AWARD_FAIL:
      return {
        ...state,
        deleteAward: {
          ...state.deleteAward,
          loading: false,
          error: action.error
        }
      }
    case PARTICIPANTS_SERVICE_CHANGE_AWARD_MODE:
      return {
        ...state,
        changeAwardMode: {
          ...state.changeAwardMode,
          loading: true,
          loaded: false
        }
      }
    case PARTICIPANTS_SERVICE_CHANGE_AWARD_MODE_SUCCESS:
      return {
        ...state,
        changeAwardMode: {
          ...state.changeAwardMode,
          loading: false,
          loaded: true,
          detail: action.result
        }
      }
    case PARTICIPANTS_SERVICE_CHANGE_AWARD_MODE_FAIL:
      return {
        ...state,
        changeAwardMode: {
          ...state.changeAwardMode,
          loading: false,
          error: action.error
        }
      }
    case PARTICIPANTS_SERVICE_RECOVER:
      return {
        ...state,
        recover: {
          ...state.recover,
          loading: true,
          loaded: false
        }
      }
    case PARTICIPANTS_SERVICE_RECOVER_SUCCESS:
      return {
        ...state,
        recover: {
          ...state.recover,
          loading: false,
          loaded: true,
          detail: action.result
        }
      }
    case PARTICIPANTS_SERVICE_RECOVER_FAIL:
      return {
        ...state,
        recover: {
          ...state.recover,
          loading: false,
          error: action.error
        }
      }
    default:
      return state
  }
}

export function getParticipants(params = {}, baseFilter, listReadParams) {

  let defaultReadParams = 'INLINE_AWARD_ORGANIZATIONS,MAX_AWARD_LVL_INFO,PARTICIPANT_SUMMARY_INFO,BULK_RESTRICTION_INFO'

  if (listReadParams) {
    defaultReadParams = `${defaultReadParams},${listReadParams}`
  }

  return {
    types: [
      GET_PARTICIPANTS_LIST,
      GET_PARTICIPANTS_LIST_SUCCESS,
      GET_PARTICIPANTS_LIST_FAIL
    ],
    promise: client =>
      client.get(
        `api/participants?with=${defaultReadParams}${routeParams(
          params,
          baseFilter,
          { baseSort: '+firstName' }
        )}`
      )
  }
}


export function getParticipantsGrid(params = {}, baseFilter) {
  return {
    types: [
      GET_PARTICIPANTS_GRID_LIST,
      GET_PARTICIPANTS_GRID_LIST_SUCCESS,
      GET_PARTICIPANTS_GRID_LIST_FAIL
    ],
    promise: client =>
      client.post(
        `apiv2/participant/overview/list`, {
          data: {
            sort: getApiSort(params.sort || "+firstName"),
            filter: buildParticipantsGridFilter(params, baseFilter),
            paging: getApiPaging(params.offset, params.limit),
            options: {
              getRecordList: true,
              getTotalCount: false
            }
          }
        }
      )
  }
}


export function getParticipantsGridCount(params = {}, baseFilter) {
  return {
    types: [
      GET_PARTICIPANTS_GRID_COUNT,
      GET_PARTICIPANTS_GRID_COUNT_SUCCESS,
      GET_PARTICIPANTS_GRID_COUNT_FAIL
    ],
    promise: client =>
      client.post(
        `apiv2/participant/overview/list`, {
          data: {
            filter: buildParticipantsGridFilter(params, baseFilter),
            options: {
              getRecordList: false,
              getTotalCount: true
            }
          }
        }
      )
  }
}

function buildParticipantsGridFilter(params, baseFilter) {
  const filterBuilder = getApiFilterBuilder(params.filter)
  const allAwardLevelsFilter = filterBuilder.extractFilter('allAwardLevels')

  if (allAwardLevelsFilter && allAwardLevelsFilter.value) {
    filterBuilder
      .named('awardLevel@in', 'anyAwardLevel', i => i.value)
      .named('search@like', 'search')
      .parse('personState@eq', 'personState')
      .named('awardState@in', 'anyAwardState', i => i.value)
      .named('awardLeader@in', 'anyAwardLeaderId', i => i.value)
      .named('awardCenter@in', 'anyAwardOrganizationId', i => i.value)
      .named('activityCategory@eq', 'anyActivityCategoryId')
      .named('participantLabel@or', 'participantLabels', i => i.value ? i.label : null)
      .named('lastLogFrom@gte', 'anyAwardLastLogFrom')
      .named('lastLogFrom@lt', 'anyAwardLastLogTo')
      .named('awardLabel@or', 'anyAwardLabels', i => i.value ? i.label : null)
  }
  else {
    filterBuilder
      .named('awardLevel@in', 'lastAwardLevel', i => i.value)
      .named('search@like', 'search')
      .parse('personState@eq', 'personState')
      .parse('awardState@in', 'awardState', i => i.value)
      .parse('awardLeader@in', 'awardLeaderId', i => i.value)
      .parse('awardCenter@in', 'awardOrganizationId', i => i.value)
      .named('activityCategory@eq', 'lastActivityCategoryId')
      .named('participantLabel@or', 'participantLabels', i => i.value ? i.label : null)
      .parse('lastLogFrom@gte', 'lastLogDate')
      .parse('lastLogFrom@lt', 'lastLogDate')
      .named('awardLabel@or', 'lastAwardLabels', i => i.value ? i.label : null)
  }

  switch (baseFilter.name) {
    case 'myParticipants':
      filterBuilder.hard('myParticipantsOnly')
      break
    case 'awardUnitParticipants':
      filterBuilder.hard('anyAwardOrganizationId', parseInt(baseFilter.value))
      break
    case 'leaderParticipants':
      filterBuilder.hard('anyAwardLeaderId', parseInt(baseFilter.value))
      break
    case 'organizationParticipants':
      filterBuilder.hard('anyAwardOrganizationParentId', parseInt(baseFilter.value))
      break
    case 'assessorParticipantsActivity':
      break
    case 'assessorAJParticipants':
      break
    case 'assessorRPParticipants':
      break
    default:
      break
  }

  return filterBuilder.build()
}


export function setParticipantsGridFilter(filterBy) {
  return {
    type: SET_GRID_FILTER,
    filterBy
  }
}

export function setParticipantsGridParams(options) {
  return {
    type: SET_GRID_PARAMS,
    options
  }
}


export function setParticipantsSelected(selectedIds, bulkType) {
  return {
    type: SET_PARTICIPANTS_LIST_SELECTED,
    selectedIds,
    bulkType
  }
}

export function toggleParticipantsAllSelected(selectedIds, selectableIds) {
  return {
    type: TOGGLE_PARTICIPANTS_ALL_SELECTED,
    selectedIds,
    selectableIds
  }
}

export function getAssessorsActivityParticipants(
  params = {},
  baseFilter,
  { assessorId = null, organizationId= null } = {}
) {

  return {
    types: [
      GET_ASSESSOR_ACTIVITY_PARTICIPANTS_LIST,
      GET_ASSESSOR_ACTIVITY_PARTICIPANTS_LIST_SUCCESS,
      GET_ASSESSOR_ACTIVITY_PARTICIPANTS_LIST_FAIL
    ],
    promise: client =>
      client.get(
        `api/assessors/${assessorId}/organization/${organizationId}/participants?filterType=ACTIVITY&with=LABELS,INLINE_AWARD_ORGANIZATIONS,ASSESSOR_ACTIVITIES${routeParams(
            {
              filter: get(params, 'assessor.activity.filter'),
              limit: get(params, 'assessor.activity.limit'),
              offset: get(params, 'assessor.activity.offset'),
              sort: get(params, 'assessor.activity.sort')
            },
          null,
          { baseSort: '+firstName' }
        )}`
      )
  }
}

export function getAssessorsAJParticipants(
    params = {},
    baseFilter,
    { assessorId = null, organizationId= null } = {}
) {
  return {
    types: [
      GET_ASSESSOR_AJ_PARTICIPANTS_LIST,
      GET_ASSESSOR_AJ_PARTICIPANTS_LIST_SUCCESS,
      GET_ASSESSOR_AJ_PARTICIPANTS_LIST_FAIL
    ],
    promise: client =>
        client.get(
            `api/assessors/${assessorId}/organization/${organizationId}/participants?filterType=AJ&with=LABELS,INLINE_AWARD_ORGANIZATIONS,ASSESSOR_ACTIVITIES${routeParams(
                {
                  filter: get(params, 'assessor.aj.filter'),
                  limit: get(params, 'assessor.aj.limit'),
                  offset: get(params, 'assessor.aj.offset'),
                  sort: get(params, 'assessor.aj.sort')
                },
                null,
                { baseSort: '+firstName' }
            )}`
        )
  }
}

export function getAssessorsRPParticipants(
    params = {},
    baseFilter,
    { assessorId = null, organizationId= null } = {}
) {
  return {
    types: [
      GET_ASSESSOR_RP_PARTICIPANTS_LIST,
      GET_ASSESSOR_RP_PARTICIPANTS_LIST_SUCCESS,
      GET_ASSESSOR_RP_PARTICIPANTS_LIST_FAIL
    ],
    promise: client =>
        client.get(
            `api/assessors/${assessorId}/organization/${organizationId}/participants?filterType=RP&with=LABELS,INLINE_AWARD_ORGANIZATIONS,ASSESSOR_ACTIVITIES${routeParams(
                {
                filter: get(params, 'assessor.rp.filter'),
                limit: get(params, 'assessor.rp.limit'),
                offset: get(params, 'assessor.rp.offset'),
                sort: get(params, 'assessor.rp.sort')
                },
                null,
                { baseSort: '+firstName' }
            )}`
        )
  }
}

export function getParticipant(id, readParams = '') {
  const query = `ADDRESS,AWARDS,ORGANIZATION,PARTICIPANT_REGISTRATION,AWARD_LEVEL,AWARD_PAYMENT,AWARD_LEADER,PARTICIPANT_DETAILS,PARTICIPANT_DETAILS_NOTE,LABELS,${readParams}`

  return {
    types: [GET_PARTICIPANT, GET_PARTICIPANT_SUCCESS, GET_PARTICIPANT_FAIL],
    promise: client => client.get(`api/participants/${id}?with=${query}`)
  }
}

export function getParticipantSummary(id) {
  const query = 'ADVENTUROUS_JOURNEYS,AJ_PREP_TRAINING,RESIDENTIAL_PROJECT,ACTIVITIES,ACTIVITIES_WITH_PROGRESS,AWARD_LEVEL'

  return {
    types: [GET_PARTICIPANT_SUMMARY, GET_PARTICIPANT_SUMMARY_SUCCESS, GET_PARTICIPANT_SUMMARY_FAIL],
    promise: client => client.get(`api/participants/${id}/summary?precalculatedData=true&with=${query}`)
  }
}

export function createParticipant(data) {
  return {
    types: [
      CREATE_PARTICIPANT,
      CREATE_PARTICIPANT_SUCCESS,
      CREATE_PARTICIPANT_FAIL
    ],
    promise: client =>
      client.post('api/participants', {
        data
      })
  }
}

export function deleteParticipant(id, { reason } = {}) {
  const reasonQuery = reason ? `?reason=${encodeURIComponent(reason)}` : ''

  return {
    types: [
      DELETE_PARTICIPANT,
      DELETE_PARTICIPANT_SUCCESS,
      DELETE_PARTICIPANT_FAIL
    ],
    promise: client => client.del(`api/participants/${id}${reasonQuery}`)
  }
}

export function updateParticipant(
  data,
  update = 'PERSONAL_DETAILS,CONTACT,ADDRESS,PARTICIPANT_DETAILS,PARTICIPANT_DETAILS_NOTE,CHANGE_PERSON_STATE'
) {
  return {
    types: [
      UPDATE_PARTICIPANT,
      UPDATE_PARTICIPANT_SUCCESS,
      UPDATE_PARTICIPANT_FAIL
    ],
    promise: client =>
      client.post(`api/participants/${data.id}/edit?update=${update}`, {
        data
      })
  }
}

export function approveParticipant(id, data) {
  return {
    types: [
      APPROVE_PARTICIPANT,
      APPROVE_PARTICIPANT_SUCCESS,
      APPROVE_PARTICIPANT_FAIL
    ],
    promise: client =>
      client.post(`api/participants/${id}/registrationAssessment`, {
        data
      })
  }
}

export function deleteParticipantRegistration(
  participantId,
  { reason } = {},
  { participantRegistrationId } = {}
) {
  const reasonQuery = reason ? `?reason=${encodeURIComponent(reason)}` : ''

  return {
    types: [REMOVE_PART_REG, REMOVE_PART_REG_SUCCESS, REMOVE_PART_REG_FAIL],
    promise: client =>
      client.del(
        `api/participants/${participantId}/participant-registrations/${participantRegistrationId}${reasonQuery}`
      )
  }
}

export function sendEmailInvitation(email, participantName) {
  return {
    types: [
      SEND_EMAIL_INVITE,
      SEND_EMAIL_INVITE_SUCCESS,
      SEND_EMAIL_INVITE_FAIL
    ],
    promise: client =>
      client.post(
        `api/participant-registrations/send-email-invitation?participantName=${participantName}`,
        {
          data: {
            value: email
          }
        }
      )
  }
}

export function exportParticipants(params = {}, baseFilter) {
  return {
    types: [
      EXPORT_PARTICIPANTS_LIST,
      EXPORT_PARTICIPANTS_LIST_SUCCESS,
      EXPORT_PARTICIPANTS_LIST_FAIL
    ],
    promise: client =>
      client.get(
        `api/participants?with=INLINE_AWARD_ORGANIZATIONS,MAX_AWARD_LVL_INFO,PARTICIPANT_SUMMARY_INFO,LABELS${routeParams(
          {
            filter: params.filter
          },
          baseFilter,
          { baseSort: '+firstName' }
        )}`
      )
  }
}

export function exportParticipantsGrid(params = {}, baseFilter) {
  return {
    types: [
      EXPORT_PARTICIPANTS_GRID_LIST,
      EXPORT_PARTICIPANTS_GRID_LIST_SUCCESS,
      EXPORT_PARTICIPANTS_GRID_LIST_FAIL
    ],
    promise: client =>
      client.post(
        `apiv2/participant/overview/list`, {
          data: {
            sort: getApiSort(params.sort),
            filter: buildParticipantsGridFilter(params, baseFilter),
            options: {
              getRecordList: true,
              getTotalCount: false
            }
          }
        }
      )
  }
}

export function sendConfirmationEmail(participantId) {
  return {
    types: [
      SEND_CONFIRM_EMAIL,
      SEND_CONFIRM_EMAIL_SUCCESS,
      SEND_CONFIRM_EMAIL_FAIL
    ],
    promise: client =>
      client.post(`api/participants/${participantId}/resend-confirmation-email`)
  }
}

export function mergeAccounts(sourceParticipantId, targetParticipantId) {
  return {

    types: [
      PARTICIPANTS_SERVICE_MERGE,
      PARTICIPANTS_SERVICE_MERGE_SUCCESS,
      PARTICIPANTS_SERVICE_MERGE_FAIL
    ],
    promise: client =>
      client.post('api/participants/service/award/merge', {
        data: {
          sourceParticipantId,
          targetParticipantId,
          force: false
        }
      })
  }
}

export function deleteAward(participantId, awardLevel) {
  return {

    types: [
      PARTICIPANTS_SERVICE_DELETE_AWARD,
      PARTICIPANTS_SERVICE_DELETE_AWARD_SUCCESS,
      PARTICIPANTS_SERVICE_DELETE_AWARD_FAIL
    ],
    promise: client =>
        client.post('api/participants/service/award/delete', {
          data: {
            participantId,
            awardLevel
          }
        })
  }
}

export function changeAwardMode(participantId, awardLevel) {
  return {

    types: [
      PARTICIPANTS_SERVICE_CHANGE_AWARD_MODE,
      PARTICIPANTS_SERVICE_CHANGE_AWARD_MODE_SUCCESS,
      PARTICIPANTS_SERVICE_CHANGE_AWARD_MODE_FAIL
    ],
    promise: client =>
        client.post('api/participants/service/award/change-mode', {
          data: {
            participantId,
            awardLevel
          }
        })
  }
}


export function recoverParticipant(deletedParticipantId) {
  return {

    types: [
      PARTICIPANTS_SERVICE_RECOVER,
      PARTICIPANTS_SERVICE_RECOVER_SUCCESS,
      PARTICIPANTS_SERVICE_RECOVER_FAIL
    ],
    promise: client =>
        client.post('api/participants/service/participant/recover', {
          data: {
            deletedParticipantId
          }
        })
  }
}

// create own reducer if needed
export function passwordResetRequest(email) {
  return {
    types: [
      PASSWORD_REQUEST_RESET,
      PASSWORD_REQUEST_RESET_SUCCESS,
      PASSWORD_REQUEST_RESET_FAIL
    ],
    promise: client =>
      client.post('api/passwords/reset-request', {
        removeToken: true,
        removeUserType: true,
        data: {
          value: email
        }
      })
  }
}

export function setParticipantsFilter(filterBy) {
  return {
    type: SET_FILTER,
    filterBy
  }
}

export function setAssessorActivityParticipantsParams(options) {
  return {
    type: SET_ASS_ACT_PART_PARAMS,
    options
  }
}

export function setAssessorActivityParticipantsFilter(filterBy) {
  return {
    type: SET_ASS_ACT_PART_FILTER,
    filterBy
  }
}

export function setAssessorAJParticipantsFilter(filterBy) {
  return {
    type: SET_ASS_AJ_PART_FILTER,
    filterBy
  }
}

export function setAssessorAJParticipantsParams(options) {
  return {
    type: SET_ASS_AJ_PART_PARAMS,
    options
  }
}

export function setAssessorRPParticipantsFilter(filterBy) {
  return {
    type: SET_ASS_RP_PART_FILTER,
    filterBy
  }
}

export function setAssessorRPParticipantsParams(options) {
  return {
    type: SET_ASS_RP_PART_PARAMS,
    options
  }
}

export function setParticipantsParams(options) {
  return {
    type: SET_PARAMS,
    options
  }
}

export function setInitialParams() {
  return {
    type: SET_INITIAL_PARAMS
  }
}

export function removeParticipantsDetailData() {
  return {
    type: REMOVE_DETAIL_DATA
  }
}

export function removeParticipantsCache() {
  return {
    type: SET_DISABLED_CACHE
  }
}

export function bulkParticipantsReset() {
  return {
    type: BULK_PARTICIPANTS_RESET
  }
}

export function bulkParticipants(participantIds, bulkType, opts) {
  const types = [
    BULK_PARTICIPANTS,
    BULK_PARTICIPANTS_SUCCESS,
    BULK_PARTICIPANTS_FAIL
  ]

  switch (bulkType) {
    case PARTICIPANTS_BULK.inactive.id:
      return {
        types,
        promise: client =>
          client.post(
            'api/participants/archive/bulk',
            {
              data: {
                personIds: participantIds
              }
            }
          )
        }

    case PARTICIPANTS_BULK.resendParentalConsent.id:
      return {
        types,
        promise: client =>
          client.post(
            'api/participants/awards/resend-parental-consent-link/bulk',
            {
              data: {
                participantIds
              }
            }
          )
      }

    case PARTICIPANTS_BULK.changeParentalConsent.id:
      return {
        types,
        promise: client =>
            client.post(
                'api/participants/awards/change-parental-consent/bulk',
                {
                  data: {
                    participantIds
                  }
                }
            )
      }

    case PARTICIPANTS_BULK.resendConfirmationEmail.id:
      return {
        types,
        promise: client =>
            client.post(
                'api/participants/awards/resend-confirmation-email/bulk',
                {
                  data: {
                    participantIds
                  }
                }
            )
      }

    case PARTICIPANTS_BULK.toCeremony.id:
      return {
        types,
          promise: client =>
          client.post(
            'api/participants/award/change-state/bulk',
            {
              data: {
                participantIds,
                state: 'CEREMONY'
              }
            }
          )
      }

    case PARTICIPANTS_BULK.offlineToComplete.id:
      return {
        types,
        promise: client =>
          client.post(
            'api/participants/award/change-state/offline/bulk',
            {
              data: {
                participantIds,
                note: opts
              }
            }
          )
      }

    case PARTICIPANTS_BULK.nextLevelInvitation.id:
      return {
        types,
        promise: client =>
          client.post(
            'api/participants/awards/next-level-registration-invitation/bulk',
            {
              data: {
                participantIds
              }
            }
          )
      }

    case PARTICIPANTS_BULK.transferParticipants.id:
      return {
        types,
        promise: client =>
          client.post(
            'api/participants/awards/change-leader/bulk',
            {
              data: {
                participantIds,
                leaderId: opts.leaderId
              }
            }
          )
      }

    default:
      throw new Error(`${bulkType} not implemented`)
  }
}
